import { onMounted, onUnmounted, toValue, type MaybeRefOrGetter } from "vue";

interface Registration {
  fn: () => void;
  priority: number;
  when: MaybeRefOrGetter<boolean>;
  id: number;
}

let nextId = 0;
const registrations: Registration[] = [];
let attached = false;

function onKeydown(e: KeyboardEvent) {
  if (e.key !== "Escape") return;

  const active = registrations.filter((r) => toValue(r.when));
  if (!active.length) return;

  const top = active.reduce((best, r) => {
    if (r.priority > best.priority) return r;
    if (r.priority === best.priority && r.id > best.id) return r;
    return best;
  });
  top.fn();
}

interface UseAppEscapeKeyOptions {
  priority?: number;
  when?: MaybeRefOrGetter<boolean>;
}

export function useAppEscapeKey(handler: () => void, options: UseAppEscapeKeyOptions = {}) {
  const reg: Registration = {
    fn: handler,
    priority: options.priority ?? 0,
    when: options.when ?? true,
    id: nextId++,
  };

  onMounted(() => {
    registrations.push(reg);
    if (!attached) {
      window.addEventListener("keydown", onKeydown);
      attached = true;
    }
  });

  onUnmounted(() => {
    const idx = registrations.indexOf(reg);
    if (idx !== -1) registrations.splice(idx, 1);
    if (!registrations.length && attached) {
      window.removeEventListener("keydown", onKeydown);
      attached = false;
    }
  });
}
